import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CenterRegistrationForm from "./CenterRegistrationForm";
import { allSharedComponents } from "../../../shared";
import {
  SpotActions,
  SubscriptionActions,
  authActions,
  centerActions,
} from "../../../redux/actions";
import {
  countryConstants,
  viewPathConstants,
  translationConstants,
} from "../../../constants";

const { GeneralLogo, BaseForm, NavBar, CustomModal } = allSharedComponents;

const CenterRegistrationPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isShow, setShow] = useState(true);

  const toggleModal = () => {
    setShow((prev) => !prev);
    dispatch(centerActions.setFormState(null));
  };

  const toLogin = () => navigate(viewPathConstants.DEFAULT_PATH);
  const toRegisteration = () => navigate(viewPathConstants.REGISTRATION);

  useEffect(() => {
    dispatch(authActions.fetchCities(countryConstants.SAUDIA_ARABIA));
    const body = {
      length: null,
    };
    dispatch(SpotActions.GetAllPublicSpots(body));
    dispatch(
      SubscriptionActions.GetAllSubscriptionPrices({ isLoading: false })
    );
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="background-image">
        <CustomModal
          size="lg"
          scrollable
          show={isShow}
          setShow={toggleModal}
          closeBtnClasses={"login-modal-close-btn"}
          isMoveBack={true}
        >
          <BaseForm>
            <GeneralLogo />
            <CenterRegistrationForm />
          </BaseForm>
        </CustomModal>
      </div>
    </>
  );
};

export default CenterRegistrationPage;
